"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = _interopRequireWildcard(require("../../utils/theming"));

var _constants = require("@match/react-component-library/components/theme/constants");

var StyledSvg = (0, _theming.default)('svg')(function (_ref) {
  var color = _ref.color;
  return {
    fill: color
  };
});

function Logo(_ref2) {
  var _ref2$light = _ref2.light,
      light = _ref2$light === void 0 ? false : _ref2$light,
      _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? _constants.SEMANTIC_COLOR_NAME.CORE1_100 : _ref2$color,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100%' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '100%' : _ref2$height,
      _ref2$alignX = _ref2.alignX,
      alignX = _ref2$alignX === void 0 ? 'left' : _ref2$alignX,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'default' : _ref2$size,
      siteName = _ref2.siteName;
  var theme = (0, _theming.useTheme)();
  var themeName = theme.branding.name;
  var logoSprite = typeof theme.components.logo.url === 'function' ? theme.components.logo.url() : theme.components.logo.url;
  var fillColor = theme.palette[color];

  if (light) {
    fillColor = theme.palette.light;
  } else if (dark) {
    fillColor = theme.palette.core1_100;
  }

  return _react.default.createElement(StyledSvg, {
    "aria-label": siteName,
    color: fillColor,
    height: height,
    width: width
  }, _react.default.createElement("use", {
    xlinkHref: "".concat(logoSprite, "#").concat(themeName, "-").concat(size, "-").concat(alignX)
  }));
}

var _default = _react.default.memo(Logo);

exports.default = _default;